module.exports = __webpack_public_path__ + "assets/img/3a066a97d6416ac93e97b8eebcda25fd.svg";